function getAppToLinkedRepositoriesMap (apps) {
    return apps.reduce((acc, app) => {
        const { id } = app;

        acc[id] = apps.filter((application) => application.__typename === "AppComponent" && application.applicationInstanceId === id);

        return acc;
    }, {});
}

export {
    getAppToLinkedRepositoriesMap
};
